import { toast } from "react-toastify";
import { api } from "../../Lib/constants";
import { getAuthHeader } from "../../Lib/utils";
import {
    ADD_REMINDER,
    ADD_REMINDER_FAILED,
    REMINDER,
    REMINDER_FAILED,
    REMINDER_SUCCESS,
    UPDATE_REMINDER,
    UPDATE_REMINDER_FAILED,
    UPDATE_REMINDER_SUCCESS
} from "./actionTypes"
import moment from "moment/moment";

export const getAllRemindersList = (id, data) => async (dispatch) => {
    dispatch({ type: REMINDER });

    try {
        const response = await api(`reminders/signalRemindersList/${id}`, "get", data, getAuthHeader());
        dispatch({
            type: REMINDER_SUCCESS,
            payload: response?.data,
        });
        return response
    } catch (error) {
        console.error("Error fetching reminders:", error);
        dispatch({ type: REMINDER_FAILED, payload: error?.message });
    }
};

export const addReminder = (data) => async (dispatch) => {
    dispatch({
        type: ADD_REMINDER,
    })
    try {
        const response = await api(`reminders/add`, "post", data, getAuthHeader());
        dispatch({
            type: ADD_NOTICE_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("while Adding reminder error ====>>>", error);
        return dispatch({
            type: ADD_REMINDER_FAILED,
            payload: error?.message,
        });
    }
}

export const updateReminder = (id, data) => async (dispatch) => {
    dispatch({
        type: UPDATE_REMINDER,
    })
    try {
        const response = await api(`reminders/update/${id}`, "put", data, getAuthHeader())
        toast.success("Updated Successfully");
        dispatch({
            type: UPDATE_REMINDER_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("while updating reminder error ====>>>", error);
        dispatch({
            type: UPDATE_REMINDER_FAILED,
            payload: error?.message,
        });
    }
}

export const updateRemindersStatus = (ids) => async (dispatch) => {
    try {
        const response = await api(`reminders/complete`, "put", { ids }, getAuthHeader());
        toast.success("Reminders marked as completed");
        return response;
    } catch (error) {
        console.error("Error completing reminders:", error);
        toast.error("Failed to mark reminders as completed");
    }
};
